/** @type {import('tailwindcss').Config} */
const plugin = require('tailwindcss/plugin');

module.exports = {
	content: ['./**/**/*.php', './src/**/*.js', './blocks/**/*.js'],
	theme: {
		transitionDuration: {
			DEFAULT: '300ms',
		},
		boxShadow: {
			DEFAULT: '0 20px 60px rgba(0, 0, 0, 0.08)',
			small: '-8px 8px 32px 0 rgba(0, 0, 0, 0.16);',
			verticalslide: '-10px 16px 20px 0 rgba(0, 0, 0, 0.07);',
			medium: '-24px 24px 64px 0 rgba(0, 0, 0, 0.08);',
			thick: '-32px 32px 64px 0 rgba(0, 0, 0, 0.16);',
			'mobile-menu': '-24px 24px 64px 0px rgba(0, 0, 0, 0.08);',
			'mobile-card': '-18px 18px 42px 0px rgba(0, 0, 0, 0.08);',
			none: '0 0 #000',
		},
		colors: {
			primary: {
				DEFAULT: 'var(--strl-primary)',
				20: 'color-mix(in srgb, var(--strl-primary) 40%, black)',
				30: '#C4E6C2',
				110: 'color-mix(in srgb, var(--strl-primary) 80%, black)',
			},
			'primary-accent': '#3AAA35',
			secondary: {
				DEFAULT: 'var(--strl-secondary)',
				50: 'color-mix(in srgb, var(--strl-secondary) 50%, white)',
			},
			tertiary: {
				DEFAULT: 'var(--strl-tertiary)',
				25: 'color-mix(in srgb, var(--strl-tertiary) 25%, white)',
				50: 'color-mix(in srgb, var(--strl-tertiary) 50%, white)',
				120: 'color-mix(in srgb, var(--strl-tertiary) 120%, black)',
			},
			accent: {
				DEFAULT: '#A8299D',
				30: 'color-mix(in srgb, #A8299D 30%, white)',
				80: 'color-mix(in srgb, #A8299D 80%, black)',
			},
			gray: '#CACACA',
			'gray-light': '#f2f2f2',
			'gray-lighter': '#ccc',
			'gray-dark': '#222',
			'border-mobile': '#e6e6e6',
			white: '#fff',
			black: {
				DEFAULT: '#000',
				20: 'color-mix(in srgb, #000 20%, white)',
				70: 'color-mix(in srgb, #000 70%, white)',
			},
			alert: '#cc4b37',
			'gf-alert': '#B00020',
			transparent: 'transparent',
		},
		fontSize: {
			sm: '14px',
			base: '16px',
			lg: '20px',
			xl: '24px',
			h1: 'clamp(28px, 4vw, 44px)',
			h2: 'clamp(24px, 3.25vw, 40px)',
			h3: 'clamp(20px, 2.6vw, 32px)',
			h4: 'clamp(18px, 2.1vw, 24px)',
			h5: 'clamp(16px, 1.6vw, 20px)',
			h6: 'clamp(16px, 1.3vw, 16px)',
		},
		fontFamily: {
			body: ['Poppins', 'sans-serif'],
			header: ['Poppins', 'sans-serif'],
			icons: ['Font Awesome 6 Pro', 'Font Awesome 6 Brands'],
		},
		extend: {
			backgroundImage: {
				locateme: 'url("/src/img/location-crosshairs.svg")',
				dropdown: 'url("/src/img/angle-down.svg")',
				'arrow-right': 'url("/src/img/arrow-right-green.svg")',
				'gf-validation-icon': 'url("/src/img/gf-error-icon.svg")',
			},
			backgroundPosition: {
				'right-18': 'right 18px center',
			},
			lineHeight: {
				tightSm: '110%',
				tight: '120%',
				tightXl: '130%',
				medium: '150%',
				relaxed: '175%',
			},
			screens: {
				mobile: '320px',
				'3xl': '1921px',
				laptop: '1339px',
			},
			gap: {
				'x-auto': 'var(--strl-gap)',
				'y-auto': 'var(--strl-gap)',
				auto: 'var(--strl-gap)',
			},
			flex: {
				'col-1': '0 0 calc(var(--strl-column-size) * 1)',
				'col-2': '0 0 calc(var(--strl-column-size) * 2)',
				'col-3': '0 0 calc(var(--strl-column-size) * 3)',
				'col-4': '0 0 calc(var(--strl-column-size) * 4)',
				'col-5': '0 0 calc(var(--strl-column-size) * 5)',
				'col-6': '0 0 calc(var(--strl-column-size) * 6)',
				'col-7': '0 0 calc(var(--strl-column-size) * 7)',
				'col-8': '0 0 calc(var(--strl-column-size) * 8)',
				'col-9': '0 0 calc(var(--strl-column-size) * 9)',
				'col-10': '0 0 calc(var(--strl-column-size) * 10)',
				'col-11': '0 0 calc(var(--strl-column-size) * 11)',
				full: '0 0 100%',
			},
		},
	},
	plugins: [
		plugin(function ({ addVariant }) {
			addVariant('hocus', ['&:hover', '&:focus-visible']);
		}),
	],
	safelist: [
		{
			pattern: /grid-cols-(1[0-2]|[1-9])/,
			variants: ['sm', 'md', 'lg', 'xl'],
		},
		{
			pattern: /facetwp-([a-z])/,
		},
	],
};
